"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Rating = Rating;
exports["default"] = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _config = require("./config");
var _ratingNumber = require("./rating-number");
var _styledRating = require("./styled-rating");
var _excluded = ["dataTestId", "size", "rating", "showRating", "reviewLinkText", "reviewLink"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var propTypes = {
  dataTestId: _propTypes["default"].string,
  rating: _propTypes["default"].number,
  showRating: _propTypes["default"].bool,
  reviewLinkText: _propTypes["default"].string,
  reviewLink: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['small', 'medium', 'large']), _propTypes["default"].shape({
    xxs: _propTypes["default"].string,
    xs: _propTypes["default"].string,
    s: _propTypes["default"].string,
    m: _propTypes["default"].string,
    l: _propTypes["default"].string,
    xl: _propTypes["default"].string,
    xxl: _propTypes["default"].string
  })])
};
var defaultProps = {
  dataTestId: null,
  rating: 0,
  showRating: false,
  reviewLinkText: null,
  reviewLink: null,
  size: 'large'
};
function Rating(_ref) {
  var dataTestId = _ref.dataTestId,
    size = _ref.size,
    rating = _ref.rating,
    showRating = _ref.showRating,
    reviewLinkText = _ref.reviewLinkText,
    reviewLink = _ref.reviewLink,
    others = _objectWithoutProperties(_ref, _excluded);
  var getResponsiveFontSize = function getResponsiveFontSize() {
    var _buildResponsiveSize = (0, _fuseUtils.buildResponsiveSize)(size),
      _buildResponsiveSize2 = _slicedToArray(_buildResponsiveSize, 1),
      isResponsive = _buildResponsiveSize2[0];
    if (isResponsive) {
      var processedSize = {};
      Object.keys(size).forEach(function (viewport) {
        processedSize[viewport] = _config.ratingCssConfig[size[viewport]].fontSize;
      });
      return processedSize;
    }
    return _config.ratingCssConfig[size].fontSize;
  };
  function renderReview(text, link) {
    if (link) {
      return /*#__PURE__*/_react["default"].createElement(_styledRating.StyledLink, {
        href: link,
        size: size,
        "data-testid": dataTestId && "".concat(dataTestId, "__review")
      }, text);
    }
    return /*#__PURE__*/_react["default"].createElement(_styledRating.StyledReview, {
      size: getResponsiveFontSize(),
      type: "paragraph",
      "data-testid": dataTestId && "".concat(dataTestId, "__review")
    }, text);
  }
  var screenReaderText = "".concat(rating, " out of 5 stars");
  return /*#__PURE__*/_react["default"].createElement(_styledRating.Container, _extends({
    "data-testid": dataTestId,
    size: size
  }, others), /*#__PURE__*/_react["default"].createElement(_styledRating.Stars, {
    rating: rating,
    size: size,
    "data-testid": dataTestId && "".concat(dataTestId, "__stars-number"),
    "data-rating": rating
  }), /*#__PURE__*/_react["default"].createElement(_styledRating.StyledDiv, {
    size: size
  }, showRating ? /*#__PURE__*/_react["default"].createElement(_ratingNumber.RatingNumber, {
    rating: rating,
    size: size
  }) : /*#__PURE__*/_react["default"].createElement(_fuseUtils.SrOnly, null, screenReaderText), reviewLinkText && renderReview(reviewLinkText, reviewLink)));
}
Rating.propTypes = propTypes;
Rating.defaultProps = defaultProps;
var _default = exports["default"] = Rating;